import React from 'react'
import PropTypes from 'prop-types'

function ImageWrapper({
  isDragging, isSelected, isActive, isHovered, children,
}) {
  const styleClasses = []

  if (isActive) {
    styleClasses.push('is-active')
  }

  if (isSelected) {
    styleClasses.push('is-selected')
  }

  if (isDragging) {
    styleClasses.push('is-dragging')
  }

  if (isHovered) {
    styleClasses.push('is-hovered')
  }

  return <div className={`image-container ${styleClasses.join(' ')}`}>{children}</div>
}

ImageWrapper.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isHovered: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
}

export default ImageWrapper
